import { Injectable } from '@angular/core'

interface EyeDropper {
    open(): Promise<EyeDropperResult>
  }

interface EyeDropperResult {
    sRGBHex: string
}

@Injectable()
export class EyeDropperService {
  private eyeDropper: EyeDropper | null = null

  constructor() {
    if ('EyeDropper' in window) {
      this.eyeDropper = new (window as any).EyeDropper()
    } else {
      console.warn('EyeDropper API is not supported in this browser.')
    }
  }

  async pickColor(): Promise<string | null> {
    if (this.eyeDropper) {
      try {
        const result = await this.eyeDropper.open()
        return result.sRGBHex
      } catch (error) {
        console.error('Failed to pick color:', error)
        return null
      }
    }
    return null
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/eyedropper.service.ts